export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "producer": {
            "self": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Productor"])},
            "organization_producer": {
              "producer_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código"])},
              "formalized": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formalizado"])},
              "active": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activo"])}
            },
            "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nombres"])},
            "lastname": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Apellidos"])},
            "producer_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DNI/CE"])},
            "gender_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Género"])},
            "birth_date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fecha de nacimiento"])},
            "producer_crops": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cultivos"])}
          }
        }
      },
      "en": {
        "model": {
          "producer": {
            "_self": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Producer data"])},
            "organization_producer": {
              "producer_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code"])},
              "formalized": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formalized"])},
              "active": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Active"])}
            },
            "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
            "lastname": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lastname"])},
            "producer_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID"])},
            "gender_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gender"])},
            "birth_date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Birthday"])},
            "producer_crops": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crops"])}
          }
        }
      }
    }
  })
}